<template>
	<Loader v-if="loading" />
	<div v-else class="content">
		<h1>Email #{{ getId() }}</h1>
		<div class="large-margin-top">

			<div class="flex">
				<div class="padding-right" style="width: 450px;">
					<div class="input-row small-margin-bottom" v-if="email.log">
						<span class="label">Subject</span>
						<div>{{ email.log.subject }}</div>
					</div>

					<template v-if="email.transaction">
						<div class="input-row small-margin-bottom">
							<span class="label">Created at</span>
							<div><Format type="date" :time="true" :value="email.transaction.created_at" /></div>
						</div>
						<div class="input-row small-margin-bottom">
							<span class="label">Sent to</span>
							<div>{{ email.transaction.recipient }}</div>
						</div>
						<div class="input-row small-margin-bottom">
							<span class="label">Template ID</span>
							<div>{{ email.transaction.email_template_id }}</div>
						</div>
						<div class="input-row small-margin-bottom">
							<span class="label">Delay until</span>
							<div><Format type="date" :time="true" :value="email.transaction.delay_until" /></div>
						</div>
						<div class="input-row small-margin-bottom">
							<span class="label">Sent at</span>
							<div><Format type="date" :time="true" :value="email.transaction.sent_at" /></div>
						</div>
					</template>

					<div class="margin-top">
						<button :disabled="saving" v-on:click="resend()">Re-send</button>
					</div>

					<div v-if="email.transaction" class="margin-top">
						<h3>Resources</h3>
						<Json v-if="email.transaction.resources" :data="JSON.parse(email.transaction.resources)" />
					</div>
				</div>
				<div class="flex-grow">
					<div style="border: 1px solid #ccc; box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2); padding: 30px;">
						<div v-if="preview_html" v-html="preview_html"></div>
					</div>
				</div>
			</div>

		</div>
	</div>
</template>

<script>
import Vue from 'vue'

export default {
  data: () => ({
    loading: false,
    saving: false,
    email: {},
    preview_html: false
  }),
  methods: {
    load () {
      Vue.$api.get('/email/' + this.getId(), {}, {
        before: () => this.loading = true,
        always: () => this.loading = false,
        callback: data => this.parse(data)
      })
    },
    resend () {
      Vue.$api.post('/email/' + this.getId() + '/resend', {}, {
        before: () => this.saving = true,
        always: () => this.saving = false,
        callback: data => {
          alert('Sent :-)')
        }
      })
    },
    parse (data) {
      this.email = data

      if (data.preview) {
        this.preview_html = data.preview
      }
    },
    getId () {
      return this.$route.params.id
    }
  },
  created () {
    this.load()
  }
}
</script>
